var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"import",attrs:{"id":"import"}},[_c('ImportCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }